// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TakingChargeDto, TestingDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class TakingChargeApiClient extends BaseCRUDApiClient<TakingChargeDto> {
  baseUrl = this.config.apiEndpoint + '/taking-charge';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  createTesting(entityId: string) {
    return this.http.post<Partial<TestingDto>>(
      `${this.baseUrl}/create-testing`,
      {
        entityId: entityId,
      },
    );
  }
}
